export default "__VITE_ASSET__BhbkV_o___"